import { render, staticRenderFns } from "./GSelectLicao.vue?vue&type=template&id=2de36a7b"
import script from "./GSelectLicao.vue?vue&type=script&lang=js"
export * from "./GSelectLicao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports